/**
 * A reopened round says why (F16.5 G): the stream's `round.state_changed` from locked back to open is kept for the session, so the participant's screen can read "your facilitator reopened round N".
 * Per session, in memory: after a reload the reason is gone, and the round simply reads as open.
 */
import { useSyncExternalStore } from "react";
import type { SseEvent } from "@bsim/contracts";

const reopened = new Map<string, number>();
const listeners = new Set<() => void>();

/** Called for every stream event; keeps only a locked → open change. */
export function noteStateChange(e: SseEvent): void {
  if (e.type !== "round.state_changed") return;
  if (e.data.from === "locked" && e.data.round.state === "open") reopened.set(e.cohortId, e.data.round.roundNo);
  else if (e.data.round.state !== "open") reopened.delete(e.cohortId);
  listeners.forEach((l) => l());
}

/** The round number the facilitator reopened in this cohort, while it is still open; else null. */
export const useReopenedRound = (cohortId: string): number | null =>
  useSyncExternalStore((l) => { listeners.add(l); return () => { listeners.delete(l); }; }, () => reopened.get(cohortId) ?? null);
